import { defineStore } from 'pinia';
import PublicService from '@/services/public.service';
import Course from '@/classes/Courses/Course.class';

export const useCoursesStore = defineStore('courses', {
    state: () => ({
        id_module: null,
        list: [],
    }),
    actions: {
        async fetchAll() {
            this.list = [];
            let res = await PublicService.getCourses(this.id_module);
            if (res) {
                this.set(res);
            }
        },
        set(data) {
            this.list = [];
            for (let i = 0; i < data.length; i++) {
                let course = new Course();
                course.set(data[i]);
                this.list.push(course);
            }
        }
    },
    getters: {
        allCoursesComplets() {
            let allCoursesComplets = true;
            for (let i = 0; i < this.list.length; i++) {
                if (!this.list[i].is_complet(this.list)) {
                    return false;
                }
            }
            return allCoursesComplets;
        },
        has_courses() {
            return this.list.length > 0;
        },
        has_courses_with_equipe() {
            return this.list.filter((course) => course.is_equipe_course()).length > 0;
        }

    },
});